import React from "react";
import { shape, bool } from "prop-types";
import GridTable from "pages/_components/GridTable/GridTable";
import FormattedDate from "pages/_components/FormattedDate";
import { debinStatusActions, statusTagColor } from "util/debin";
import InfoTag from "pages/debinPayments/_components/InfoTag";
import useActionByDebinState from "pages/debinPayments/hooks/useActionByDebinState";
import CustomData from "pages/_components/CustomData/CustomData";
import CustomButton from "pages/_components/CustomButton/CustomButton";
import FormattedAmount from "pages/_components/FormattedAmount";

const ItemRow = ({ scheduledDebin, isDesktop }) => {
    const { options } = useActionByDebinState(debinStatusActions, scheduledDebin, null);

    return (
        <>
            <GridTable.Data
                columnStart={1}
                rowStart={1}
                alignX={isDesktop ? "center" : "left"}
                alignY={isDesktop ? "center" : "start"}>
                <CustomData
                    titleText="debin.scheduled.table.creationDate"
                    titleTextType="I18N"
                    valueText={<FormattedDate showTime={false} date={scheduledDebin.creationDate} />}
                    valueTextType="TEXT"
                />
            </GridTable.Data>

            <GridTable.Data
                columnStart={isDesktop ? 2 : 1}
                rowStart={isDesktop ? 1 : 2}
                alignX={isDesktop ? "center" : "left"}
                alignY={isDesktop ? "center" : "start"}>
                <CustomData
                    titleText="debin.scheduled.table.applicant"
                    titleTextType="I18N"
                    valueText={scheduledDebin.seller.documentNumber}
                    valueTextType="TEXT"
                />
            </GridTable.Data>

            <GridTable.Data
                columnStart={isDesktop ? 3 : 1}
                rowStart={isDesktop ? 1 : 3}
                alignX={isDesktop ? "center" : "left"}
                alignY={isDesktop ? "center" : "start"}>
                <CustomData
                    titleText="debin.scheduled.table.amount"
                    titleTextType="I18N"
                    valueText={
                        <FormattedAmount
                            className="data-label"
                            currency={scheduledDebin.debin.amount.currency}
                            quantity={scheduledDebin.debin.amount.quantity}
                        />
                    }
                />
            </GridTable.Data>

            <GridTable.Data
                columnStart={isDesktop ? 4 : 1}
                rowStart={isDesktop ? 1 : 4}
                alignX={isDesktop ? "center" : "left"}
                alignY={isDesktop ? "center" : "start"}>
                <CustomData
                    titleText="debin.scheduled.table.installment"
                    titleTextType="I18N"
                    valueText={scheduledDebin.debin.installmentLimit}
                />
            </GridTable.Data>

            <GridTable.Data columnStart={isDesktop ? 5 : 1} alignY={isDesktop ? "center" : "start"}>
                {isDesktop ? (
                    <InfoTag
                        type="info"
                        message={scheduledDebin.status}
                        tagBackground={statusTagColor(scheduledDebin.status)}
                    />
                ) : (
                    <CustomData
                        titleText="debin.scheduled.table.status"
                        titleTextType="I18N"
                        valueText={
                            <InfoTag
                                type="info"
                                message={scheduledDebin.status}
                                tagBackground={statusTagColor(scheduledDebin.status)}
                            />
                        }
                    />
                )}
            </GridTable.Data>

            <GridTable.Data columnStart={isDesktop ? 6 : 3} rowStart={1} alignX="end">
                {options.length > 0 && (
                    <CustomButton pullRight icon="images/figma/icon/menu-mobile.svg" options={options} />
                )}
            </GridTable.Data>
        </>
    );
};
ItemRow.propTypes = {
    scheduledDebin: shape().isRequired,
    isDesktop: bool.isRequired,
};

export default ItemRow;
